<select  multiple  (change)="handleChange($event)" style="width:210px; height: 140px;"  >
    <option *ngFor="let x of list" [value]="x.id" >{{x.name}}</option>
</select>

Selcted: {{selected}}
